var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95458 0C8.80612 0.00588648 8.62988 0.0598159 8.51236 0.152027L0.368247 5.98986C0.195754 6.12617 0.0903453 6.34579 0.0909449 6.56756V17.2703C0.0909929 17.6524 0.433723 18 0.810463 18H6.55618C6.93292 18 7.27565 17.6524 7.2757 17.2703V14.3514C7.2757 13.3954 8.01203 12.6487 8.95458 12.6487C9.89712 12.6487 10.6335 13.3954 10.6335 14.3514V17.2703C10.6335 17.6524 10.9762 18 11.353 18H17.0987C17.4754 18 17.8182 17.6524 17.8182 17.2703V6.56756C17.8182 6.34579 17.7134 6.12617 17.5409 5.98986L9.39679 0.152027C9.26349 0.047357 9.19442 0.013303 8.95458 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.77473fbefe8b793eefcdfbc7d8aadf29.svg";
export { ForwardRef as ReactComponent };